import submitCommand from '../../../services/submitCommand';
import { Step } from '../../steps/models/course';

export const addFeedbackResponseUser = (
  courseId: string,
  task: Step,
  email: string,
  firstName: string,
  callbackHost: string,
  initiatingUserId: string
) => {
  const cmd = {
    id: courseId,
    taskInstance: task,
    email: email.trim(),
    firstName: firstName,
    callbackHost: callbackHost,
    initiatingUserId: initiatingUserId,
  };

  return submitCommand(courseId, cmd, 'AddFeedbackResponseUser', 'FeedbackResponseUserAdded', 'TaskListInstanceError');
};
